import { buildRpcPayload, parseRpcResponse } from "./rpcCore.js";
import type { RpcFetchOptions, JsonRpcResponse } from "./../../../interfaces/index.js";

export async function fetchRpcDirect<
  TResult,
  TParams extends readonly unknown[]
>(
  method: string,
  params: TParams,
  opts: RpcFetchOptions = {}
): Promise<TResult> {

  const payload = buildRpcPayload(method, params);

  const res = await fetch(opts.url ?? "https://api.mainnet-beta.solana.com", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...opts.headers,
    },
    body: JSON.stringify(payload),
    signal: opts.signal,
  });

  if (!res.ok) {
    throw new Error(`RPC HTTP error ${res.status}`);
  }

  const json = (await res.json()) as JsonRpcResponse<TResult>;
  return parseRpcResponse(json);
}
